// The Intelligence Board — the "crown jewel" of seat-one. Designed for
// the second monitor: dispatcher's command surface during a bank.
//
// Two perspectives on the same data, both share the workspace + comms +
// alerts state via IntelligenceContext:
//   - Map view  (default): spatial concourse for ambient awareness
//   - Board view (toggle): sortable triage table for peak-bank ops
//
// Top context bar is always visible; map/board fills the rest.

import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { IntelligenceProvider } from './intelligence/IntelligenceContext';
import ContextBar from './intelligence/ContextBar';
import ConcourseMap from './intelligence/ConcourseMap';
import BoardView from './intelligence/BoardView';
import Workspace from './intelligence/Workspace';
import { ReplayOverlay } from './intelligence/ReplayScrubber';
import { C } from './styles';

function IntelligenceView() {
  const [view, setView] = useState('map'); // 'map' | 'board'

  return (
    <IntelligenceProvider>
      <Box sx={{
        flex: 1, display: 'flex', flexDirection: 'column',
        minHeight: 0, minWidth: 0,
        backgroundColor: '#0a0d14',
      }}>
        <ContextBar />

        {/* View toggle strip */}
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: 0.5,
          px: 1.5, py: 0.5,
          borderBottom: `1px solid ${C.border}`,
          backgroundColor: 'rgba(0, 0, 0, 0.25)',
          flexShrink: 0,
        }}>
          {[
            { key: 'map',   label: 'Map',   icon: MapIcon       },
            { key: 'board', label: 'Board', icon: TableRowsIcon },
          ].map(t => {
            const Icon = t.icon;
            const active = view === t.key;
            return (
              <Box
                key={t.key}
                onClick={() => setView(t.key)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 0.5,
                  px: 1.25, py: 0.4,
                  cursor: 'pointer',
                  fontSize: '0.7rem', fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase',
                  color: active ? C.accent : C.textMuted,
                  backgroundColor: active ? 'rgba(249, 182, 18, 0.10)' : 'transparent',
                  border: `1px solid ${active ? C.accent : 'transparent'}`,
                  borderRadius: 0.5,
                  '&:hover': { color: active ? C.accent : C.textSecondary },
                }}
              >
                <Icon sx={{ fontSize: 14 }} />
                <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit', letterSpacing: 'inherit' }}>
                  {t.label}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box sx={{
          flex: 1, display: 'flex', position: 'relative',
          minHeight: 0, minWidth: 0,
        }}>
          {view === 'map' && <ConcourseMap />}
          {view === 'board' && (
            <>
              <BoardView />
              {/* Workspace cards + minimized dock work in board view too */}
              <Workspace />
            </>
          )}
          {/* Replay overlay sits over both views when active */}
          <ReplayOverlay />
        </Box>
      </Box>
    </IntelligenceProvider>
  );
}

export default IntelligenceView;
